import type { OwnerRequirementState } from "@/lib/types";

export function cloneOwnerRequirementItem(item: OwnerRequirementState): OwnerRequirementState {
  return {
    id: item.id,
    text: item.text,
    done: item.done,
    source_user_id: item.source_user_id ?? null,
    source_name: item.source_name ?? null,
    created_at: item.created_at ?? null,
    updated_at: item.updated_at ?? null,
  };
}
